import { useState } from "react";
import { NavLink } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../assets/css/header.css";
import brand from "../assets/images/Brand_Logo.png";

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    if (isMenuOpen) setIsMenuOpen(false);
    window.scrollTo(0, 0);
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light fixed-top shadow-sm">
        <div className="container">
          <NavLink className="navbar-brand d-flex align-items-center" to="/" onClick={closeMenu}>
            <img src={brand} alt="brand logo" className="brand-logo" />
          </NavLink>
          <button
            className={`navbar-toggler border-0 ${isMenuOpen ? "collapsed" : ""}`}
            type="button"
            onClick={toggleMenu}
            aria-expanded={isMenuOpen}
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className={`collapse navbar-collapse ${isMenuOpen ? "show" : ""}`}>
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              {[
                { path: "/", label: "Home" },
                { path: "/about", label: "About" },
                { path: "/services", label: "Services" },
                { path: "/products", label: "Products" },
                { path: "/contact", label: "Contact" },
              ].map((item) => (
                <li key={item.path} className="nav-item mx-lg-2">
                  <NavLink
                    className={({ isActive }) =>
                      `nav-link px-3 py-2 rounded-pill ${
                        isActive ? "active fw-semibold text-white" : "text-dark hover-effect"
                      }`
                    }
                    to={item.path}
                    onClick={closeMenu}
                    style={({ isActive }) => ({
                      backgroundColor: isActive ? "#3C348D" : "transparent",
                      transition: "all 0.3s ease",
                    })}
                  >
                    {item.label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </nav>

      <style jsx>{`
        .navbar {
          background-color: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(10px);
        }

        .hover-effect:hover {
          color: #3C348D !important;
          background-color: rgba(60, 52, 141, 0.1);
        }

        .nav-link {
          position: relative;
          transition: all 0.3s ease;
        }

        .navbar-collapse {
          transition: all 0.3s ease-in-out;
        }

        .brand-logo {
          height: 100%;
          max-width: 100%;
          object-fit: contain;
        }

        @media (max-width: 992px) {
          .nav-link {
            padding: 12px 15px !important;
            margin: 5px 0;
          }

          .navbar-collapse {
            padding: 20px 0;
          }
        }
      `}</style>
    </>
  );
}

export default Header;

